"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var zapier_logo_svg_1 = __importDefault(require("@ClientAssets/Images/integrations/zapier-logo.svg"));
var MountReactComponent_1 = __importDefault(require("MountReactComponent/MountReactComponent"));
var IntegrationsOnboarding_1 = require("SettingsAngular/Integrations/IntegrationsOnboarding");
var IntegrationsTileset_1 = __importDefault(require("./IntegrationsTileset"));
var ViewState;
(function (ViewState) {
    ViewState["Default"] = "default";
    ViewState["FilteringResults"] = "filtering-results";
    ViewState["FilteringEmpty"] = "filtering-empty";
    ViewState["Categorised"] = "categorised";
})(ViewState || (ViewState = {}));
exports.default = (function (di, make, createUi, isAdmin, Search, Button, controller, multiSelectDropdownFactory, openIntegrationSettings) {
    var currQuery = "";
    var currSelectedCategories = [];
    var filteredIntegrations = [];
    var onSearch = function (query, action) {
        if (action === "enter" || action === "clear" || action === "type") {
            currQuery = query;
            buildIntegrationTiles();
        }
    };
    var searchOptions = {
        size: "fit-container",
        theme: "bolder",
    };
    var searchBox = new Search("Search...", onSearch, searchOptions);
    var categories = controller.getIntegrationCategories().map(function (category) {
        return {
            name: category,
        };
    });
    var categoryFilter = multiSelectDropdownFactory.create(categories, function (lastSelected, allSelected) {
        if (allSelected.length > 0) {
            currSelectedCategories = allSelected;
        }
        else {
            ui.selectedCategories = [];
            currSelectedCategories = [];
        }
        buildIntegrationTiles();
    }, {
        title: "Filter integrations",
        updateTitleOnSelection: true,
        useDeselectAllButton: true,
    });
    var buildIntegrationTiles = function () {
        var currViewState = getViewState();
        if (currViewState === ViewState.Categorised) {
            ui.selectedCategories = buildCategorisedIntegrations(currSelectedCategories);
        }
        else if (currViewState === ViewState.FilteringResults || currViewState === ViewState.FilteringEmpty) {
            filteredIntegrations = controller.getIntegrations(currQuery);
            if (filteredIntegrations.length > 0) {
                filteringTileset.integrations = filteredIntegrations;
            }
        }
    };
    var buildCategorisedIntegrations = function (selectedCategories) {
        var e_1, _a;
        var categorisedIntegrations = [];
        try {
            for (var selectedCategories_1 = __values(selectedCategories), selectedCategories_1_1 = selectedCategories_1.next(); !selectedCategories_1_1.done; selectedCategories_1_1 = selectedCategories_1.next()) {
                var category = selectedCategories_1_1.value;
                var currentCategoryTileset = make(IntegrationsTileset_1.default, {
                    integrations: controller.getIntegrationsInCategory(category.name, currQuery),
                    options: {
                        showResultsCount: true,
                        resultsCategory: category.name,
                    },
                });
                categorisedIntegrations.push(currentCategoryTileset);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selectedCategories_1_1 && !selectedCategories_1_1.done && (_a = selectedCategories_1.return)) _a.call(selectedCategories_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return categorisedIntegrations;
    };
    var filteringTileset = make(IntegrationsTileset_1.default, {
        integrations: controller.getIntegrations(),
        options: {
            showResultsCount: true,
        },
    });
    var emptyResultsTileset = make(IntegrationsTileset_1.default, {
        integrations: controller.getSpecificIntegrations([
            "intercom",
            "sfdc",
            "slack",
            "xero",
            "googleAnalytics",
            "stripe",
        ]),
        options: {},
    });
    var defaultFirstGroup = make(IntegrationsTileset_1.default, {
        integrations: controller.getIntegrations(null, { takeFirst: 9 }),
        options: {},
    });
    var defaultRemainingGroup = make(IntegrationsTileset_1.default, {
        integrations: controller.getIntegrations(null, { skipFirst: 9 }),
        options: {},
    });
    var openZapierSettings = function () {
        openIntegrationSettings("zapier");
    };
    var exploreZapierButton = new Button(openZapierSettings, "Explore", {
        theme: "secondary",
        size: "medium",
    });
    var integrationsOnboarding = function () {
        return (0, IntegrationsOnboarding_1.mountIntegrationsOnboarding)((0, MountReactComponent_1.default)(createUi, di));
    };
    var getViewState = function () {
        var hasQuery = !!currQuery;
        var hasCategories = currSelectedCategories.length > 0;
        if (hasCategories) {
            return ViewState.Categorised;
        }
        else if (hasQuery) {
            if (filteredIntegrations.length > 0) {
                return ViewState.FilteringResults;
            }
            else {
                return ViewState.FilteringEmpty;
            }
        }
        else {
            return ViewState.Default;
        }
    };
    var ui = createUi(require("./IntegrationsList.html"), {
        filterableIntegrations: filteringTileset.ui,
        emptyResultsIntegrations: emptyResultsTileset.ui,
        defaultFirstGroup: defaultFirstGroup.ui,
        defaultRemainingGroup: defaultRemainingGroup.ui,
        integrationsOnboarding: integrationsOnboarding(),
        selectedCategories: [],
        openZapierSettings: openZapierSettings,
        exploreZapierButton: exploreZapierButton.ui,
        select: controller.openIntegrationSettings,
        isAdmin: isAdmin,
        search: searchBox.ui,
        categoryFilter: categoryFilter,
        zapierLogo: zapier_logo_svg_1.default,
        isViewState: function (stateName) {
            return getViewState() === stateName;
        },
    });
    return ui;
});
